export const randomId = (): string =>
  Math.floor(Math.random() * 1e9).toString(16);
